import React, { useState } from 'react';

const ContactFormModal = ({ isOpen, onClose, isSecondForm }) => {
    const [formValues, setFormValues] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    if (!isOpen) return null;

    const fields = [
        { label: 'Nickname', name: 'nickname', type: 'text' },
        { label: 'Email', name: 'email', type: 'email' },
        isSecondForm
            ? { label: 'Planned Rental Days', name: 'plannedRentalDays', type: 'number' }
            : { label: 'Location of GPUs', name: 'location', type: 'text' },
        { label: 'Type of GPUs', name: 'type', type: 'text' },
        isSecondForm
            ? { label: 'Number of GPUs Needed', name: 'number', type: 'number' }
            : { label: 'Number of GPUs You Have', name: 'number', type: 'number' },
        { label: 'Telegram', name: 'telegram', type: 'text' },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const formWithMeta = {
        formSource: isSecondForm ? 'Rent GPU' : 'Provide GPU',
        ...formValues,
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            const res = await fetch('https://formspree.io/f/mzbygkoz', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify(formWithMeta),
            });

            if (res.ok) {
                setSubmitted(true);
                setFormValues({});
                setTimeout(() => {
                    onClose();
                    setSubmitted(false);
                }, 2000);
            } else {
                alert('Submission failed. Please try again later.');
            }
        } catch (err) {
            console.error(err);
            alert('An error occurred while submitting the form.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-[95%] sm:w-[90%] md:w-[80%] lg:w-[70%] max-w-3xl p-4 sm:p-6 md:p-8 shadow-lg">
                <h2 className="text-xl font-semibold mb-6 text-center">Contact Information</h2>
                {submitted ? (
                    <p className="text-center text-green-600 font-semibold">Submission successful!</p>
                ) : (
                    <form
                        className="grid grid-cols-2 gap-6 text-sm sm:text-base"
                        onSubmit={handleSubmit}
                    >
                        {fields.map(({ label, name, type }) => (
                            <div key={name} className="flex flex-col">
                                <label className="mb-1 font-semibold" htmlFor={name}>
                                    *{label}
                                </label>
                                <input
                                    id={name}
                                    name={name}
                                    type={type}
                                    required
                                    value={formValues[name] || ''}
                                    onChange={handleChange}
                                    className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                        ))}

                        <div className="col-span-2 flex justify-end space-x-4 mt-4">
                            <button
                                type="submit"
                                disabled={submitting}
                                className="px-6 py-2 bg-blue-600 text-white rounded-full font-semibold hover:bg-blue-700 transition"
                            >
                                {submitting ? 'Submitting...' : 'Confirm'}
                            </button>
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-6 py-2 border border-blue-600 text-blue-600 rounded-full font-semibold hover:bg-blue-50 transition"
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

const GPU = ({ data, id }) => {
    // 用一个状态记录弹窗是否打开，及哪个按钮打开（1 或 2）
    const [modalState, setModalState] = useState({ isOpen: false, formType: 1 });

    return (
        <section
            id={id}
            className="py-12 sm:py-14 md:py-28 pb-20 sm:pb-24 lg:pb-32 xl:pb-40"
            style={{
                backgroundImage: `url(${data.img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <div className="w-full px-4 lg:w-[70%] lg:max-w-[1440px] mx-auto md:text-center">
                <div className="space-y-12 md:mx-auto">
                    <h3 className="text-white font-semibold text-3xl sm:text-4xl xl:text-4xl">
                        {data.title}
                    </h3>
                    <p className="text-white text-base sm:text-lg lg:text-xl mx-auto text-center break-words whitespace-normal">
                        {data.subTitle}
                    </p>
                </div>

                <div className="mt-6 sm:mt-8 md:mt-12 lg:mt-16 xl:mt-20 flex justify-center gap-4 sm:gap-6 lg:gap-10 flex-wrap">
                    <button
                        onClick={() => setModalState({ isOpen: true, formType: 1 })}
                        className="px-6 sm:px-8 lg:px-10 py-3 sm:py-3.5 lg:py-4 
               bg-white hover:bg-gray-200 
               rounded-full text-blue-500 font-semibold 
               text-sm sm:text-base lg:text-lg 
               transition min-w-[140px] sm:min-w-[180px] lg:min-w-[200px] 
               flex items-center justify-center"
                    >
                        {data.button1}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 sm:w-6 lg:w-7 h-5 sm:h-6 lg:h-7 ml-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                    <button
                        onClick={() => setModalState({ isOpen: true, formType: 2 })}
                        className="px-6 sm:px-8 lg:px-10 py-3 sm:py-3.5 lg:py-4
             bg-transparent border-2 border-white text-white 
             hover:opacity-50 
             rounded-full font-semibold 
             text-sm sm:text-base lg:text-lg 
             transition duration-200 ease-in-out 
             min-w-[140px] sm:min-w-[180px] lg:min-w-[200px] 
             flex items-center justify-center"
                    >
                        {data.button2?.text || data.button2}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 sm:w-6 lg:w-7 h-5 sm:h-6 lg:h-7 ml-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            <ContactFormModal
                isOpen={modalState.isOpen}
                onClose={() => setModalState({ isOpen: false, formType: 1 })}
                isSecondForm={modalState.formType === 2}
            />
        </section>
    );
};

export default GPU;
